import React from "react";
import { Button, Tree, Upload } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useItemModel } from "../itemModel";
import { useNavModel } from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { importPropsConfig } from "@/utils/importFile";
import { AuthButton } from "@/components/auth/AuthButton";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { ResourcesAuthBtn } from "@/types/ResourcesAuthEnum";
import { mianCode } from "@/utils/constants";
export const DataBox = () => {
    const { selectedRowKeys,
        updateEditFormVal,
        loadData,
        exportData,
        downloadTpl, } = useItemModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            return;
        }
        let vehicleEditKey = "13-6-2";
        let isFindNav = findNav(vehicleEditKey);
        if (!isFindNav) {
            addNav(vehicleEditKey, { id: selectedRowKeys[0] as string, mode: "edit" });
        } else {
            globalPrompt("modal", {
                title: "维修项目跳转详情",
                type: "warning",
                text: "您还有维修项目详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(vehicleEditKey, { id: selectedRowKeys[0] as string, mode: "edit" });
                    updateEditFormVal({});
                }
            })
        }
    }
    const goCustomer = () => {
        addNav("13-5-1");
    }
    const action = <>
        <AuthButton
            // resCode="MaintenanceItemsAdd"
            resCode={ResourcesAuthBtn[mianCode]["MaintenanceItemsAdd"]}
            onClick={() => addNav("13-6-1", { id: "", mode: "add" })}
            // name="新增"
            name={Locale["Add"]}
        />
        <AuthButton
            // resCode="MaintenanceItemsEdit"
            resCode={ResourcesAuthBtn[mianCode]["MaintenanceItemsEdit"]}
            onClick={onEdit}
            // name="编辑"
            name={Locale["Edit"]}
        />
        <AuthButton
            // resCode="MaintenanceItemsImport"
            resCode={ResourcesAuthBtn[mianCode]["MaintenanceItemsImport"]}
        >
            <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/vrm-sa/base/item/import`, loadData)}>
                <Button className="mr-5" type="link" shape="round">{Locale["Import"]}</Button>
            </Upload>
        </AuthButton>
        <AuthButton
            // resCode="MaintenanceItemsDownloadTheTemplate"
            resCode={ResourcesAuthBtn[mianCode]["MaintenanceItemsDownloadTheTemplate"]}
            onClick={() => { downloadTpl() }}
            // name="下载模板"
            name={Locale["Download template"]}

        />

        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { addNav("13-6-1", { id: "", mode: "add" }) }}
        >新增</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onEdit}
        >编辑</Button>
        <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/vrm-sa/base/item/import`, loadData)}>
            <Button className="mr-5" type="link" shape="round">导入</Button>
        </Upload>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { downloadTpl().then() }}
        >下载模板</Button> */}
    </>

    return (
        <YhBox title={action}>
            <DataTable />
        </YhBox>
    )
}
